import { useState } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

export default function Education({ member, shopId, onSaved }) {
  const [form, setForm] = useState({
    educational_qualification: member?.educational_qualification || '',
    other_qualifications:      member?.other_qualifications      || '',
  });
  const [saving, setSaving] = useState(false);
  const set = k => e => setForm(p => ({ ...p, [k]: e.target.value }));

  const save = async () => {
    setSaving(true);
    try {
      if (member?.id) {
        const { data } = await api.put(`/members/${member.id}`, form);
        onSaved(data);
      } else {
        const { data } = await api.post('/members', { shop_id: shopId, ...form });
        onSaved(data);
      }
      toast.success('Education info saved');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Save failed');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div className="form-group">
        <label className="form-label">Other Qualifications</label>
        <textarea
          className="form-textarea"
          value={form.other_qualifications}
          onChange={set('other_qualifications')}
          rows={4}
          placeholder="Professional certificates, trade qualifications…"
        />
      </div>
      <div className="form-group">
        <label className="form-label">Educational Qualification</label>
        <textarea
          className="form-textarea"
          value={form.educational_qualification}
          onChange={set('educational_qualification')}
          rows={4}
          placeholder="e.g. B.Sc. in Business, A/Ls, O/Ls…"
        />
      </div>
      <div className="section-save-bar">
        <button className="btn btn-primary" onClick={save} disabled={saving}>
          {saving ? 'Saving…' : 'Save Education'}
        </button>
      </div>
    </div>
  );
}
